import { Breadcrumb } from "antd";
import { routes } from "../../Routes/Routes";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setLikeCount } from "../../Features/User/User";
import { getWishListApi } from "../../Features/WishList/WishList";

import styles from "./index.module.scss";
import { ProductCard } from "../../Component/productCard";

function Like() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userToken = useSelector((state) => state.user?.token);
  const givewishlist = useSelector((state) => state.wishList?.wishlist);

  useEffect(() => {
    dispatch(getWishListApi(userToken));
    window.scrollTo(0, 0);
  }, [dispatch, userToken]);

  useEffect(() => {
    dispatch(setLikeCount(givewishlist?.length || 0));
  }, [givewishlist, dispatch]);

  return (
    <div className={styles.page}>
      {/* Breadcrumb */}
      <div className={styles.breadcrumbBar}>
        <div className={styles.breadcrumbInner}>
          <Breadcrumb
            className={styles.breadcrumb}
            items={[
              { title: <Link to="/">Home</Link> },
              { title: "Wishlist" },
            ]}
          />
        </div>
      </div>

      {/* Page Title */}
      <div className={styles.pageTitle}>
        <span className={styles.titleEyebrow}>The Diamond Counter</span>
        <h1 className={styles.titleText}>My Wishlist</h1>
        <div className={styles.titleLine} />
      </div>

      <div className={styles.container}>
        {givewishlist?.length > 0 ? (
          <>
            <div className={styles.itemCount}>
              <strong>{givewishlist.length}</strong> {givewishlist.length === 1 ? "item" : "items"} saved
            </div>
            <div className={styles.productGrid}>
              {givewishlist.map((item, index) => (
                <ProductCard key={item?._id || index} item={item} />
              ))}
            </div>
          </>
        ) : (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>
            <h2 className={styles.emptyTitle}>Your Wishlist Is Empty</h2>
            <p className={styles.emptyDesc}>
              Browse our collection and save your favourite pieces to revisit later.
            </p>
            <button
              type="button"
              className={styles.emptyBtn}
              onClick={() => navigate("/product/all")}
            >
              Explore Collection
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Like;
